import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingListComment } from './types/mailing-list-comment.type';

/**
 * Inserts a comment into a mailing list.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The mailing list comment data to insert.
 * @returns A promise that resolves to the operation result of the insertion.
 * @throws Will throw an error if the HTTP request fails.
 */
export const insertMailingListComment = async (instance: KyInstance, data: MailingListComment) => {
  try {
    return await instance
      .post<OperationResultWithData<number>>(
        formatString(Uri.mailingList.insertMailingListComment, data.mailingListId.toString()),
        {
          json: data,
        }
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
